<template>
  <header class="hotsugg-header">
    <form
      action="/v"
      accept-charset="utf-8"
    >
      <input
        id="keyword"
        v-model="oquery"
        name="query"
        type="text"
        autocomplete="off"
      >
      <button
        v-if="oquery"
        id="resetbtn"
        type="reset"
        class="icon_cancel"
        @click="reset"
      />
      <input
        type="hidden"
        name="w"
        value="06009900"
      >
      <input
        type="hidden"
        name="ie"
        value="utf8"
      >
      <input
        v-if="spver"
        v-model="spver"
        type="hidden"
        name="spver"
      >
    </form>
    <a
      id="cancleBtn"
      class="header_search_cancel"
      href="javascript:history.go(-1)"
    >取消</a>
  </header>
</template>

<script>
export default {
  data() {
    return {
      spver: +this.$route.query.spver === 1 ? 1 : '',
      oquery: '',
    };
  },
  methods: {
    reset() {
      this.oquery = '';
      document.querySelector('#keyword').value = '';
      window.sug.close();
      document.querySelector('#keyword').focus();
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';

.hotsugg-header {
  height: auto;
  padding: 14px;
  line-height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .header_search_cancel {
    display: block;
    margin-left: 10px;
    width: 31px;
    font-size: 15px;
    color: #222;
    @include line-clip(1);
    flex: none;
  }

  form {
    border: 1px solid #999;
    border-radius: 3px;
    height: 34px;
    overflow: hidden;
    flex: auto;
    padding: 0 32px 0 10px;
    position: relative;
    > input {
      width: 100%;
      font-size: 16px;
      color: #222;
      border: 0;
      background: 0;
      font-family: inherit;
      margin: 0;
      padding: 0;
      outline: 0;
    }

    .icon_cancel {
      width: 22px;
      height: 22px;
      @extend %-vertical-center;
      right: 10px;

      &:before,
      &:after {
        content: '';
        display: block;
        @extend %-absolute-center;
        width: 1px;
        height: 12px;
        background: #999;
        border-radius: 1px;
        transform: rotate(-45deg);
      }

      &:after {
        transform: rotate(45deg);
      }
    }
  }
}
</style>
